import type { LocationExactnessScope } from "@/entities/place";

interface GivenNameExactness {
    flags: {
        phonetic: boolean;
        similar: boolean;
        initials: boolean;
    };
    isExact: boolean;
}

interface SurnameExactness {
    flags: {
        phonetic: boolean;
        similar: boolean;
        soundex: boolean;
    };
    isExact: boolean;
}

interface RelationInstance {
    givenName: string;
    surname: string;
    secondSurname: string;
    givenNameExactness: GivenNameExactness;
    surnameExactness: SurnameExactness;
}

type RelationInstances = {
    instances: RelationInstance[];
};

type Relations = {
    father: RelationInstances;
    mother: RelationInstances;
    spouse: RelationInstances;
    child: RelationInstances;
    sibling: RelationInstances;
};

interface Types {
    trees: boolean;
    records: boolean;
    photos: boolean;
    stories: boolean;
}

interface TreePerson {
    treeId: string;
    personId: string;
}

export interface FieldData {
    value: string | null;
    relation: string | null;
    eventName: string;
    assertion: string;
    isExact: boolean;
}

export interface Fields {
    [key: string]: FieldData;
}

export type MatchMode = "rankOnly" | "mustMatch";
export interface FormValueTimespan {
    yearStart: number | null;
    yearEnd: number | null;
    matchMode: MatchMode;
    isVisible: boolean;
}

export interface FormValueEventInstance {
    date: { year: number | null; month: number | null; day: number | null; endYear?: number | null };
    gpid: string;
    location: string;
    dateProximity: { year: number | null; month: number | null; day: number | null };
    locationExactness: LocationExactnessScope | null;
    /** Whether this instance is in year-range mode (UI toggle state, used during submit transformation) */
    isRangeMode?: boolean;
}

export type FormValuesEvent = {
    instances: FormValueEventInstance[];
    relation: string | null;
    eventName: string;
};

export type FormValuesEvents = {
    [key: string]: FormValuesEvent;
};

export enum RecordSubject {
    All = "all",
    Primary = "primary",
}

export type FormValues = {
    name: RelationInstance;
    family: Relations;
    events: FormValuesEvents;
    treePerson: TreePerson;
    types: Types;
    priority: string;
    location: string[];
    fields: Fields;
    recordSubject: RecordSubject;
    showUnviewedRecordsOnly?: boolean;
    timespan: FormValueTimespan;
};
